module.exports = __webpack_public_path__ + "88deae10be6b4b3dd98fe7d7bb647144.pdf";